import {TreatmentEndoDataModel} from './treatment-endo-data.model';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';

export class TreatmentEndoEditColumnModel {
  title: string;
  model: TreatmentEndoDataModel;
  columnPropertyNames: string[];
  columnEnums: EnumValidValueItemModel[][];
}
